<main
  class="flex min-h-80vh px-app-x-m pt-not-auth-header-m md:pt-not-auth-header-d justify-center items-center"
>
  <div class="md:mt-0 grow">
    <div class="text-center text-secondary font-semibold text-24px">
      Reset Your Password
    </div>
    <div class="text-center text-14px mt-24px max-w-450px mx-auto">
      Please enter the email address you'd like your password reset information
      sent to
    </div>
    <form [formGroup]="form" class="max-w-450px ml-auto mr-auto mt-36px">
      <ib-mat-form-field-wrap
        [formCtrlName]="'email'"
        [formCtrl]="form.get('email')"
        [showClearBtn]="true"
      >
        <mat-form-field>
          <mat-label>Enter Email Address</mat-label>
          <input
            matInput
            formControlName="email"
            required
            autocomplete="email"
          />
        </mat-form-field>
      </ib-mat-form-field-wrap>

      <footer class="mt-50px flex flex-col justify-center items-center">
        <div class="relative">
          <ib-btn-wrap [isLoading]="loading">
            <button
              mat-button
              [disabled]="form.invalid || loading || isAttemptDisabled"
              class="ib-btn ib-btn-secondary"
              (click)="submit()"
            >
              Request Reset Link
            </button>
          </ib-btn-wrap>
          <div class="-bottom-24px w-full absolute flex justify-center">
            <ib-tooltip
              *ngIf="isAttemptDisabled"
              text="{{
                'Can be requested again in ' + newAttemptInSec + ' sec'
              }}"
            >
            </ib-tooltip>
          </div>
        </div>
      </footer>
    </form>
  </div>
</main>
<ib-footer></ib-footer>
